'use client'

import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/Carousel';
import WebbedHotelSquareCardV2 from '@/components/hotels/WebbedHotelSquareCardV2';
import { webbedFormatHotel } from '@/components/hotels/utils/webbedFormatHotel';

import useSetSearchParams from '@/hooks/useSetSearchParams';
import { WebbedHotel } from '@/types/webbeds';
import getNextDate from '@/utils/getNextDay';
import { deslugify } from '@/utils/slugify';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import HotelBoxV2 from '../HotelBoxV2';
import NavigateToSearchPage from '../NavigateToSearchPage';
import HotelLoading from './loading2';

export default function Recommended() {
    const { params: { checkIn = getNextDate(0), checkOut = getNextDate(1), passenger }, mainParams: { hotelName, city, country } } = useSetSearchParams();
    const [hotels, setHotels] = useState<WebbedHotel[] | null>(null);
    const [loading, setLoading] = useState(false);

    async function fetchHotels(city: string) {

        setLoading(true)

        // const res: any = await webbedGetAll({ checkIn, checkOut, city, passenger , country });
        // const { result } = JSON.parse(res);
        // setHotels(result);
        setLoading(false)
    }

    useEffect(() => {
        if (!city) return;

        const timer = setTimeout(() => {
            fetchHotels(city);
        }, 5);
        return () => clearTimeout(timer);
    }, [city]);


    const currency = Cookies.get('currency') || 'USD';

    return loading ? <HotelLoading /> : (hotels && hotels.length > 0) ? (
        <HotelBoxV2>
            <div className='flex items-end sm:items-center justify-between pb-2'>
                <h2 className="text-gray-900 flex gap-1 flex-wrap">
                    <span>Other Hotels in</span>
                    <span className='capitalize'>{deslugify(city)}</span>
                </h2>
                <NavigateToSearchPage country={country} city={city} checkIn={checkIn} checkOut={checkOut} passenger={passenger}>
                    <div className='text-xs min-w-max text-secondary-500 flex items-center gap-0.5'>
                        <span>See more</span>
                        <FontAwesomeIcon icon={faChevronRight} className='w-4 flex items-center justify-center' />
                    </div>
                </NavigateToSearchPage>
            </div>
         <Carousel className="w-full">
                <CarouselContent className='pl-3'>
                    {hotels?.map((hotel: WebbedHotel, index) => {
                        const formattedHotel = webbedFormatHotel(hotel, 2, currency);

                        return (
                            <CarouselItem key={hotel.id}
                                className="md:px-2 !basis-1/6 min-w-[208px] md:w-full md:min-w-[224px] 
                                           !w-[208px] sm:w-full  px-0.5 !h-full first:pl-4 
                                             sm:first:pl-2
                                             ">
                                <WebbedHotelSquareCardV2
                                    navigateTo={formattedHotel.navigateTo({
                                        start: getNextDate(0),
                                        end: getNextDate(1),
                                    })}
                                    hotel={formattedHotel}
                                    key={hotel.id}
                                />
                            </CarouselItem>
                        );
                    })}
                </CarouselContent>
                <CarouselPrevious className='!bg-transparent hidden md:block backdrop-blur' />
                <CarouselNext className='!bg-transparent  hidden md:block backdrop-blur' />
            </Carousel>
        </HotelBoxV2>
    ) : null; // Render nothing if hotels is empty or undefined
}
